<div class="dialog-select-file" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'音声ファイル選択' | translate}}</span>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div class="filter-field">
    <mat-form-field fxFlex="25%">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
    </mat-form-field>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let uploadedFile; let i = index"> {{ (i + 1) + (paginator.pageSize *
          paginator.pageIndex) }} </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>{{'選択' | translate}}</th>
        <td mat-cell *matCellDef="let uploadedFile">
          <button mat-stroked-button color="primary" (click)="selectFile(uploadedFile)">{{'選択' | translate}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'名称' | translate}}</th>
        <td mat-cell *matCellDef="let uploadedFile"> {{uploadedFile.file_name}} </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'登録日時' | translate}}
        </th>
        <td mat-cell *matCellDef="let uploadedFile"> {{ uploadedFile.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>